import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { clone, map, remove, size } from 'lodash';
import { Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import SVG from 'react-inlinesvg';

import { getMediaZipFiles } from 'app/api/downloads/getMediaZipFiles';
import Button from 'app/components/Button/Button';
import Icon from 'app/components/Icon/Icon';
import Spinner from 'app/components/Spinner/Spinner';
import { COUNTRIES } from 'app/utils/constants';

import 'app/modules/Downloads/components/ModalCountries/ModalCountries.scss';

export default function ModalCountries({
  title,
  idCategory,
  setIdCategory,
  viewModal,
  setViewModal,
  idsCountry,
  setIdsCountry,
  countries
}) {
  const intl = useIntl();
  const handleClose = () => {
    setViewModal(false);
    setIdsCountry([]);
    setIdCategory(null);
    setLoading(false);
  };
  const [loading, setLoading] = useState(false);

  return (
    <Modal className="modal-country-body" show={viewModal} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>
          <p className="big bold">{title}</p>
          <Icon icon="close" onClick={handleClose} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="modal-countries-title">
          {intl.formatMessage({
            id: 'controlpanel.downloads.download_file_country'
          })}
        </p>
        <div className="modal-countries">
          {map(countries, (country) => (
            <div
              key={country?.id}
              className="modal-countries__container"
              onClick={() =>
                handleClick(
                  country?.isoCode,
                  idsCountry,
                  setIdsCountry,
                  loading
                )
              }
              role="button"
              onKeyDown={() =>
                handleClick(
                  country?.isoCode,
                  idsCountry,
                  setIdsCountry,
                  loading
                )
              }
              tabIndex={0}
            >
              <div className="modal-countries__container-checkbox">
                <input
                  type="checkbox"
                  className="bb-checkbox"
                  readOnly
                  checked={idsCountry.includes(country?.isoCode)}
                  disabled={loading}
                />
              </div>
              <div className="modal-countries__container-image">
                <SVG
                  src={COUNTRIES.find((l) => l.code === country?.isoCode)?.flag}
                />
              </div>
              <div className="modal-countries__container-text">
                <p>{country?.name}</p>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={handleClose}
          text={intl.formatMessage({ id: 'controlpanel.global.back' })}
          size="big"
        />
        <Button
          onClick={async () => {
            setLoading(true);
            const request = await getMediaZipFiles(
              [idCategory],
              'csv-section',
              [],
              idsCountry
            );

            if (request?.links?.download_url) {
              window.location = request?.links?.download_url;
            }

            handleClose();
          }}
          text={intl.formatMessage({ id: 'controlpanel.global.download' })}
          size="big"
          type="primary"
          disabled={size(idsCountry) === 0 || loading === true}
          icon={loading === true ? <Spinner /> : null}
        />
      </Modal.Footer>
    </Modal>
  );
}

ModalCountries.propTypes = {
  title: PropTypes.string.isRequired,
  idCategory: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  setIdCategory: PropTypes.func.isRequired,
  viewModal: PropTypes.bool.isRequired,
  setViewModal: PropTypes.func.isRequired,
  idsCountry: PropTypes.arrayOf(PropTypes.string).isRequired,
  setIdsCountry: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      isoCode: PropTypes.string
    })
  ).isRequired
};

const handleClick = (id, idsCountry, setIdsCountry, loading) => {
  if (loading === false) {
    const cloneIdsCountry = clone(idsCountry);
    if (idsCountry.includes(id) === false) {
      cloneIdsCountry.push(id);
      setIdsCountry(cloneIdsCountry);
    } else {
      setIdsCountry(remove(cloneIdsCountry, (n) => n !== id));
    }
  }
};
